export default __webpack_public_path__ + "static/media/otherImg.2566bc2f.png";